
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc/pre-exam",
      function () {
        return require("private-next-pages/tnpsc/pre-exam.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc/pre-exam"])
      });
    }
  